import React from 'react';
import { Box, Typography } from '@mui/material';
import FileBrowser from '../components/common/FileBrowser';

export default function Documents() {
  return (
    <Box>
      <Typography variant="h4" fontWeight="bold" sx={{ mb: 3 }}>
        Gestión Documental
      </Typography>
      <FileBrowser title="Documentos" />
    </Box>
  );
}
